export function deepClone(value, seen = new WeakMap()) {
  // Handle primitives and functions (by reference)
  if (typeof value !== 'object' || value === null) return value;

  // Handle cyclic references
  if (seen.has(value)) return seen.get(value);

  let cloned;

  // Handle Date
  if (value instanceof Date) {
    cloned = new Date(value);
  }
  // Handle RegExp
  else if (value instanceof RegExp) {
    cloned = new RegExp(value.source, value.flags);
  }
  // Handle Map
  else if (value instanceof Map) {
    cloned = new Map();
    seen.set(value, cloned);
    value.forEach((val, key) => {
      cloned.set(deepClone(key, seen), deepClone(val, seen));
    });
  }
  // Handle Set
  else if (value instanceof Set) {
    cloned = new Set();
    seen.set(value, cloned);
    value.forEach(val => {
      cloned.add(deepClone(val, seen));
    });
  }
  // Handle Array
  else if (Array.isArray(value)) {
    cloned = [];
    seen.set(value, cloned);
    value.forEach((item, index) => {
      cloned[index] = deepClone(item, seen);
    });
  }
  // Handle Typed Arrays (e.g., Int32Array, Float64Array, etc.)
  else if (ArrayBuffer.isView(value)) {
    cloned = new value.constructor(value);
  }
  // Handle Objects (including class instances)
  else {
    cloned = Object.create(Object.getPrototypeOf(value));
    seen.set(value, cloned);
    Object.keys(value).forEach(key => {
      cloned[key] = deepClone(value[key], seen);
    });

    // Also copy non-enumerable and symbol properties
    Object.getOwnPropertySymbols(value).forEach(sym => {
      cloned[sym] = deepClone(value[sym], seen);
    });
  }

  return cloned;
}
